import React from "react"
import { Box } from "@mui/material"
import { AppAntSwitch } from "@components"
import { AppWebSupplierGroupsAutocomplete } from "@components/Autocomplete"
import useAutoEuropeDataInfo from "Pages/AutoEuropeTool/Page/@hooks/useDataInfo"
import { autoEuropeDrawerData, autoEuropeOriginalData } from "Pages/AutoEuropeTool/Page/@signals"
import { enrichFilterIds } from "Pages/AutoEuropeTool/Page/@utils/filterEnrich"

export default function AutoEuropeExcludeWebSuppliers() {
	const d = autoEuropeDrawerData.peek()
	const { dataInfo: idsInfo, setDataInfo: setIds } = useAutoEuropeDataInfo(d.filterGroupWebSuppliers ?? [])
	const { dataInfo: exclInfo, setDataInfo: setExcl } = useAutoEuropeDataInfo(d.filterGroupWebSuppliersExclusion ?? false)

	const isExclusion = exclInfo.value
	const ids = idsInfo.value ?? []

	const updateMode = (checked) => setExcl(checked, 'filterGroupWebSuppliersExclusion')
	const updateIds = (_, opts) => setIds(opts ?? [], 'filterGroupWebSuppliers')

	return (
		<Box>
			<AppAntSwitch
				falseText="Include web supplier groups"
				trueText="Exclude web supplier groups"
				falseIcon="circle-check"
				trueIcon="ban"
				checked={isExclusion}
				onChange={e => updateMode(e.target.checked)}
				chipSx={{ mb: 1.5 }}
			/>
			<AppWebSupplierGroupsAutocomplete
				label={isExclusion ? 'Exclude Web Supplier Groups' : 'Include Web Supplier Groups'}
				placeholder={isExclusion ? 'No groups excluded' : 'No groups included'}
				value={ids.map(o => o?.value ?? o)}
				onChange={updateIds}
				onAjax={options => { enrichFilterIds('filterGroupWebSuppliers', options, autoEuropeDrawerData, autoEuropeOriginalData); return options }}
			/>
		</Box>
	)
}